import { Form, Input } from "antd";
import * as COMMONS from "common/common";
import NumberStepper from "components/common/NumberStepper";
import { motion } from "framer-motion";

const CustomNumberStepper = ({
	name,
	label,
	primaryLightColor,
	primaryColor,
}) => {
	return (
		<>
			<p
				className="px-4 py-2 text-center text-lg font-bold mt-8 mb-4 rounded"
				style={{
					backgroundColor: primaryLightColor,
					color: primaryColor,
				}}
			>
				{label}
			</p>

			<NumberStepper name={name} />
		</>
	);
};

export default function GroupBookingForm({ primaryColor, primaryLightColor }) {
	return (
		<motion.div
			variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}
			className="mb-8"
		>
			<p
				className="px-4 py-2 text-center text-lg font-bold mt-8 mb-4 rounded"
				style={{
					backgroundColor: primaryLightColor,
					color: primaryColor,
				}}
			>
				名前
			</p>
			<Form.Item
				className="px-4"
				required
				rules={[
					{
						required: true,
						message: "※本人確認の為、フルネームの記入をお願い致します",
					},
				]}
				name="participantName"
			>
				<Input placeholder="例：山田太郎" />
			</Form.Item>

			<CustomNumberStepper
				label="参加者"
				name="participantCount"
				primaryLightColor={primaryLightColor}
				primaryColor={primaryColor}
			/>

			<CustomNumberStepper
				label="同伴者"
				name="companionCount"
				primaryLightColor={primaryLightColor}
				primaryColor={primaryColor}
			/>
		</motion.div>
	);
}
